import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

interface OverwriteWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const OverwriteWarningDialog = ({
  open,
  onClose,
  onConfirm,
}: OverwriteWarningDialogProps) => (
  <Dialog
    onClose={onClose}
    open={open}
    sx={{
      '& .MuiDialog-container': {
        alignItems: 'flex-start',
      },
    }}
    PaperProps={{
      sx: {
        width: '100%',
        maxWidth: '604px',
      },
    }}
  >
    <DialogTitle
      sx={{
        paddingX: '24px',
        paddingTop: '24px',
        paddingBottom: '16px',
      }}
    >
      <FormattedMessage defaultMessage='Overwrite Report Confirmation' />
    </DialogTitle>
    <DialogContent>
      <Typography color='#4F4F4F'>
        <FormattedMessage
          defaultMessage='Would you like to create a new final report and overwrite the existing
        report and its draft? Only 1 final report can be active at a time.'
        />
      </Typography>
    </DialogContent>
    <DialogActions
      sx={{
        padding: '24px',
      }}
    >
      <Button
        variant='outlined'
        color='inherit'
        sx={{
          textTransform: 'none',
          color: 'black',
          height: '42px',
          borderColor: '#D1D1D1',
          borderWidth: '1px',
        }}
        onClick={onClose}
      >
        <FormattedMessage defaultMessage='Cancel' />
      </Button>
      <Button
        variant='contained'
        color='blue'
        sx={{
          textTransform: 'none',
          height: '42px',
        }}
        disableElevation
        onClick={onConfirm}
      >
        <Typography fontSize={14} fontWeight={600}>
          <FormattedMessage defaultMessage='Overwrite and Create' />
        </Typography>
      </Button>
    </DialogActions>
  </Dialog>
);

export default OverwriteWarningDialog;
